// extracted by mini-css-extract-plugin
export default {"icon":"FloatingLayout_icon__WstjS","tooltip":"FloatingLayout_tooltip__OuauJ"};